import { Box, FormControlLabel } from '@mui/material';
import TranslationHelper from '../../../../../../helpers/TranslationHelper';
import { Field, FormikErrors } from 'formik';
import CheckboxWrapper from '../../../../../common/formikWrappers/CheckboxWrapper';
import React from 'react';
import FieldWrapper from '../../../../../common/formikWrappers/FieldWrapper';
import CollapseItem from '../../../../../collapseItem';
import { DeviceCreateAdvancedFormValues } from '../types';
import { TDeviceFormValues } from '../../types';
import { usePrivileges } from '@/app/state/auth/index.hooks';

type Props = {
    errors?: FormikErrors<DeviceCreateAdvancedFormValues>;
    values: TDeviceFormValues;
};

const ETollSectionContent = ({ errors, values }: Props) => {
    const [isSectionVisible, setIsSectionVisible] = React.useState(
        values.advanced.eToll.enabled
    );
    const privileges = usePrivileges();
    return (
        <>
            <Box mt={2}>
                <FormControlLabel
                    label={TranslationHelper.translate('Send data to eToll')}
                    control={
                        <Field
                            name="advanced.eToll.enabled"
                            component={CheckboxWrapper}
                            onClick={(e: React.ChangeEvent<HTMLInputElement>) =>
                                setIsSectionVisible(e.target.checked)
                            }
                        />
                    }
                />
            </Box>
            {isSectionVisible && privileges.eTollEditRegistrationData && (
                <>
                    <Field
                        name="advanced.eToll.businessNumber"
                        label={TranslationHelper.translate('Business number')}
                        component={FieldWrapper}
                        fullWidth
                        error={Boolean(errors?.eToll?.businessNumber)}
                        helperText={errors?.eToll?.businessNumber}
                    />
                    <Field
                        name="advanced.eToll.pin"
                        label={TranslationHelper.translate('PIN')}
                        component={FieldWrapper}
                        fullWidth
                        error={Boolean(errors?.eToll?.pin)}
                        helperText={errors?.eToll?.pin}
                    />
                </>
            )}
        </>
    );
};

export const ETollSection = ({ errors, values }: Props) => {
    return (
        <CollapseItem
            title={TranslationHelper.translate('eToll')}
            content={<ETollSectionContent values={values} errors={errors} />}
            collapsed={false}
        />
    );
};
